export default function localNumber(value) {
  if (!value) {
    return undefined;
  }

  if (!isNaN(value)) {
    return value.toLocaleString();
  }
}
